import FiltersCollection from '@/domain/FiltersCollection'

export const toExportable = (state) => new FiltersCollection(state).exportable




// WEBPACK FOOTER //
// ./src/store/destiny/filters/getters.js